// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"973":"dd9d29b5","1094":"8af84d34","3062":"dbd5a000","5283":"8d99dd9f","5439":"83e3085a","8390":"d3a70a92","8977":"b07f28d1","9066":"83e3085a"}[chunkId] + ".chunk.css";
};